<template>
  <div class="pa-message-app" ref="mesageApp">
    <MessageView
      :paddingBottom="editorBoxHeight"
      :isVisible="isOpenMessageView"

      @handleAdditionalSubmit="handleAdditionalSubmit"
      @handleAdditionalCancel="handleAdditionalCancel"
      @onVisibled="handleVisibledMessageView"
    />

    <EditorBox
      :isVisible="isOpenEditorBox"
      :placeHolderMessage="placeholderMessage"
      :sendButtonText="sendButtonText"
      @onSend="handleSend"
      @onVisibled="handleVisibledEditorBox"
      @onResize="handleResizeEditorBox"

      :isOpenEditorOverlay="isOpenEditorOverlay"
      :isEditorLoading="isEditorLoading"
      :editorOverlayButtonText="editorOverlayButtonText"
      @overlayClickCancel="handleOverlayClickCancel"
    />
  </div>
</template>

<script>
import MessageView from '@/components/Pages/Office/MessageApp/MessageView.vue'
import EditorBox   from '@/components/Pages/Office/MessageApp/EditorBox.vue'

import PostNewMessageMixins from '@/components/Pages/Office/MessageApp/mixins/PostNewMessageMixins.js'

export default {
  mixins : [
    PostNewMessageMixins
  ],

  components : {
    MessageView,
    EditorBox
  },

  data(){
    return {
      sendButtonText      : '発言',
      placeholderMessage  : '森飼さん、窓口業務をおねがいします。',
      isOpenEditorBox     : false,
      isOpenMessageView   : false,

      editorBoxHeight     : 0,

      isEditorLoading         : false,
      isOpenEditorOverlay     : false,
      editorOverlayButtonText : '話題を変える',
    };
  },

  computed : {
    isEnterd(){
      return this.$store.state.message.isEnterdMessageRoom;
    },

    mainContentHeight(){
      return this.$store.state.layouts.mainContentHeight;
    },

    messageRoomId(){
      return this.$store.state.message.roomId;
    },

    messageThreadId(){
      return this.$store.state.message.threadId;
    },

    tmpMessage(){
      return this.$store.state.message.tmpMessage;
    },

    preInsertMessages(){
      return this.$store.state.message.preInsertMessages;
    },

    shoudMesageRoomSofa(){
      return this.$store.state.message.shoudMesageRoomSofa;
    }
  },

  watch : {
    shoudMesageRoomSofa : {
      handler(value){
        if(value === true){
          this.placeholderMessage = 'リリカさん、窓口業務をおねがいします。';
        }else{
          this.placeholderMessage = '森飼さん、窓口業務をおねがいします。';
        }
      },
      immediate: true
    },
    
    mainContentHeight : {
      handler(value){
        this.$nextTick(() => {
          this.$refs.mesageApp.style.height = value+'px';
        });
      },

      immediate : true
    },
    
    isEnterd : {
      handler(value){
        if(value === false) return;
        
        // メッセージルーム入室時にtmpMessageが存在する場合は処理します。
        this.checkTmpMessage();

        this.$nextTick(async () => {
          await this.UXWaiting(500);
          
          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;

          this.isOpenEditorBox = true;
        });
      },
      immediate: true
    },
  },

  methods : {
    async executeChangeTopic(){
      await this.newMessage({
        wrap      : false,
        uxWaiting : 800,
        message   : 'CMD:office:changeTopic',
      });
    },

    async handleSend(message){
      await this.newMessage({
        wrap      : true,
        uxWaiting : 1000,
        message   : message
      });
    },

    async handleAdditionalSubmit(payload){
      switch(payload.additionalType){
        case 'change-name':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:changeNameComplete',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'change-password':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:changePasswordComplete',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'change-email':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:changeEmailComplete',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'regist-number':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:RegisterdNumberCode',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'change-thumbnail':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:changeThumbnailComplete',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'create-new-park':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:createParkComplete',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'question':
          if(typeof payload.options?.questionName !== 'undefined'){
            await this.newMessage({
              wrap      : false,
              uxWaiting : 800,
              message   : 'CMD:office:question:'+payload.messageId+':'+payload.options.questionName+':'+payload.options.questionValue,
            });
          }
          
          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;

        case 'regist-park-invitation':
          await this.newMessage({
            wrap      : false,
            uxWaiting : 800,
            message   : 'CMD:office:registParkInvitationComplete',
          });

          this.isOpenEditorOverlay  = false;
          this.isEditorLoading      = false;
        break;
      }
    },

    async handleAdditionalCancel(){
      // console.log('Cancel Clicked');
      // console.log(payload);
      await this.handleOverlayClickCancel();
    },

    async handleOverlayClickCancel(){
      this.isEditorLoading = true;

      await this.executeChangeTopic();
      
      this.isOpenEditorOverlay = false;
      this.isEditorLoading = false;
    },

    handleVisibledEditorBox(editorBoxHeight){
      this.editorBoxHeight = editorBoxHeight;
      this.isOpenMessageView = true;
    },

    handleResizeEditorBox(editorBoxHeight){
      this.editorBoxHeight = editorBoxHeight;
    },

    async checkPreInsertMessages(){
      if(this.preInsertMessages === null) return;

      let hasAdditionals = false;

      for(let item of this.preInsertMessages){
        await this.$store.dispatch({
          type  : 'message/attachViewList',
          value : {
            id          : item.id,
            messageId   : item.id,
            isDisabled  : false,
          }
        });

        if(item.additionals !== null){
          hasAdditionals = true;
        }
      }

      // If has additionals fields, editor turnd off.
      this.isOpenEditorOverlay  = hasAdditionals;

      await this.$store.dispatch({
        type  : 'message/updatePreInsertMessages',
        data  : null
      });
    },

    async checkTmpMessage(){
      if(this.tmpMessage === null) return;

      await this.newMessage(this.tmpMessage);
      
      await this.$store.dispatch({
        type  : 'message/updateTmpMessage',
        data  : null
      });
    },

    handleVisibledMessageView(){
      // メッセージルームがauto_refreshでない場合は過去のメッセージを入れてあげます。
      this.checkPreInsertMessages();
    }
  },
  mounted(){
    // AdditionalsのタグボタンをクリックされたときにCMDをNewMessageに送信します。
    this.$on('handleTagInfomationButtonClick', async (buttonItem) => {
      if(typeof buttonItem.slug === 'undefined') return;

      await this.newMessage({
        wrap      : false,
        uxWaiting : 1000,
        message   : 'CMD:office:'+buttonItem.slug
      });
      
      buttonItem.isLoading = false;
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
.pa-message-app{
  position:relative;
}
</style>